export default "__VITE_ASSET__Dtb0Wl27__"